export default "__VITE_ASSET__HWdasE4v__"